import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconStorybookStory({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? DEFAULT_COLOR;

    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M7 0H1a.5.5 0 0 0-.5.5v7l.007.083a.5.5 0 0 0 .822.293L4 5.54l2.67 2.336A.5.5 0 0 0 7.5 7.5v-7A.5.5 0 0 0 7 0z"/>
        </svg>
    );
}

export default IconStorybookStory;
